// extracted by mini-css-extract-plugin
module.exports = {"pintxo-carousel-slides":"CarouselSlides_pintxo-carousel-slides__ex4ur"};